import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
const initialState = {
  generationResponse: {
    actions: undefined,
    enrollment: undefined
  },
  actionsPrompt: ''
};
export default function aiAssistantReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_AI_GENERATED_ACTIONS:
      return Object.assign({}, state, {
        generationResponse: {
          actions: action.payload
        }
      });
    case ActionTypes.SET_AI_GENERATED_ENROLLMENT:
      return Object.assign({}, state, {
        generationResponse: {
          enrollment: action.payload
        }
      });
    case ActionTypes.SET_AI_ACTIONS_PROMPT:
      return Object.assign({}, state, {
        actionsPrompt: action.payload
      });
    default:
      return state;
  }
}